import { render, staticRenderFns } from "./ClientDevices.vue?vue&type=template&id=19d6872f&"
import script from "./ClientDevices.vue?vue&type=script&lang=js&"
export * from "./ClientDevices.vue?vue&type=script&lang=js&"
import style0 from "./ClientDevices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3358805848/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19d6872f')) {
      api.createRecord('19d6872f', component.options)
    } else {
      api.reload('19d6872f', component.options)
    }
    module.hot.accept("./ClientDevices.vue?vue&type=template&id=19d6872f&", function () {
      api.rerender('19d6872f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Profile/ClientDevices.vue"
export default component.exports